import { FileUtility } from './../../core/utility/fileUtility.model';
import { Observable, of } from 'rxjs';
import { ResourceInitializerService } from './../../core/services/resource-initializer.service';
import { Esito } from './../esito/esito.component';
import { REGEX } from './../../core/enums/regex.enum';
import { PublicService } from './../../core/services/public.service';
import { TranslateService } from '@ngx-translate/core';
import { FormUtility } from './../../core/utility/formUtility.model';
import { FormBuilder, FormControl, Validators, ValidatorFn, FormArray, FormGroup } from '@angular/forms';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-pagamento',
  templateUrl: './pagamento.component.html',
  styleUrls: ['./pagamento.component.scss']
})
export class PagamentoComponent {

  isRiepilogo = false;
  recaptchaKey: string | undefined = '';

  controls: {
    key: string;
    validators?: ValidatorFn | ValidatorFn[];
    value?: any;
    isFormGroup?: boolean;
    isFormArray?: boolean;
  }[] = [
    { key: 'codAccisa', validators: [Validators.required, Validators.pattern(REGEX.ACCISA)] },
    { key: 'ragioneSociale', validators: [Validators.required] },
    { key: 'cf', validators: [Validators.required, Validators.pattern(REGEX.CF)] },
    { key: 'email', validators: [Validators.required, Validators.pattern(REGEX.EMAIL)] },
    { key: 'fkProvincia', validators: [Validators.required] },
    { key: 'fkComune', validators: [Validators.required] },
    { key: 'cap', validators: [Validators.required] },
    { key: 'frazione', validators: [] },
    { key: 'indirizzo', validators: [Validators.required] },
    { key: 'txtNumero', validators: [Validators.required] },
    { key: 'fkNazione', validators: [Validators.required] },
    { key: 'annoPagamento', validators: [Validators.required, Validators.min(1900), Validators.max(2900)] },
    { key: 'meseVersamento', validators: [Validators.required] },
    { key: 'ravvedimento', value: 'NO', validators: [Validators.required] },
    { key: 'recaptcha', value: false, validators: [Validators.required] },
    { key: 'richiedenti', value: [], isFormGroup: true },
    { key: 'totale', validators: [] }
  ]

  controls_labels = {
    'codAccisa': 'Codice accisa',
    'ragioneSociale': 'Ragione sociale',
    'cf': 'Codice Fiscale',
    'email': 'Email',
    'fkProvincia': 'Provincia',
    'fkComune': 'Comune',
    'cap': 'CAP',
    'frazione': 'Frazione',
    'indirizzo': 'Indirizzo',
    'txtNumero': 'Numero civico',
    'fkNazione': 'Nazione',
    'annoPagamento': 'Anno versamento',
    'meseVersamento': 'Mese versamento',
    'ravvedimento': 'Ravvedimento',
    'tipoTributo': 'Tipologia tributo',
    'rataAddiz': 'Rata',
    'conguaglioAddiz': 'Conguaglio',
    'tipoRavvedimentoAddiz': 'Tipo ravvedimento',
    'tributoAddiz': 'Tributo',
    'sanzioneAddiz': 'Sanzione',
    'interessiAddiz': 'Interessi',
    'totaleAddiz': 'Totale Addizionale',
    'rataSost': 'Rata',
    'conguaglioSost': 'Conguaglio',
    'tipoRavvedimentoSost': 'Tipo ravvedimento',
    'tributoSost': 'Tributo',
    'sanzioneSost': 'Sanzione',
    'interessiSost': 'Interessi',
    'totaleSost': 'Totale Sostitutiva',
    'recaptcha': 'CAPTCHA',
    'totale': 'Totale'
  }

  _province = ['Bologna', 'Ferrara', 'Forli\'', 'Modena', 'Parma', 'Piacenza', 'Ravenna', 'Reggio nell\'Emilia', 'Rimini'];

  errors: { field: string, msg: string }[] = []
  alerts: { msg: string }[] = []

  public form = this.fb.group({});

  provinceOptions!: Observable<{id: number, nome: string}[]>;
  //comuneOptions!: Observable<{id: number, nome: string}[]>;
  //capOptions!: Observable<{id: number, codiceCap: string}[]>;

  comuneOld: number | undefined;
  capOld: number | undefined;

  richiedentiFormsInitialized = false;

  constructor(
    private fb: FormBuilder,
    private translate: TranslateService,
    private router: Router,
    private publicService: PublicService,
    private resourceInitializerService: ResourceInitializerService
  ) {

    for (const control of this.controls) {
      if (control.isFormGroup) {
        this.form.addControl(control.key, fb.array((control.value || {}) as any, control.validators));
      } else if (control.isFormArray) {
        this.form.addControl(control.key, fb.array((control.value || []) as any, control.validators));
      } else {
        this.form.addControl(control.key, fb.control(control.value || '', control.validators));
      }
    }

    if (this.resourceInitializerService.getResource('province')) {
      this.provinceOptions = of(this.resourceInitializerService.getResource('province'));
      this.addRichiedentiControls();
    } else {
      this.publicService.getAllProvinceRer().subscribe((response) => {
        this.provinceOptions = of(response);
        this.resourceInitializerService.addResource('province', response);
        this.addRichiedentiControls();
      });
    }

    if (router.url === '/public/riepilogo-pagamento') {
      this.isRiepilogo = true;
      this.form.disable();
      this.alerts.push({ msg: 'Verifica i dati inseriti prima di procedere.' });
      this.scrollToAlerts();
    } else {
      this.publicService.getRecaptcha().subscribe(res => {
        this.recaptchaKey = res?.key;
      });
    }
  }

  addRichiedentiControls() {
    const richiedenti = this.form.get('richiedenti') as any as FormArray;
    for (const prov of this._province) {
      const richiedente = this.fb.group({
        idProvincia: new FormControl(this.getIdProvince(prov), []),
        provincia: new FormControl(prov, []),

        tipoTributo: new FormControl('', []),
        tipoTributoRavv: new FormControl('', []),

        rataAddiz: new FormControl(0, []),
        conguaglioAddiz: new FormControl(0, []),
        tipoRavvedimentoAddiz: new FormControl('', []),
        tributoAddiz: new FormControl(0, []),
        sanzioneAddiz: new FormControl(0, []),
        interessiAddiz: new FormControl(0, []),
        totaleAddiz: new FormControl(0, []),
        rataSost: new FormControl(0, []),
        conguaglioSost: new FormControl(0, []),
        tipoRavvedimentoSost: new FormControl('', []),
        tributoSost: new FormControl(0, []),
        sanzioneSost: new FormControl(0, []),
        interessiSost: new FormControl(0, []),
        totaleSost: new FormControl(0, []),

        checked: new FormControl(false, [])
      });

      this.form.addControl(prov.toLocaleLowerCase()+'Checkbox', this.fb.control(''));
      richiedente.get('totaleAddiz')?.disable();
      richiedente.get('totaleSost')?.disable();
      richiedenti.push(richiedente);

      setTimeout(() => {
        //richiedente?.get('totaleAddiz')?.setValidators([Validators.min(0)]);

        richiedente.get('tipoRavvedimentoAddiz')?.valueChanges.subscribe(() => {
          this.resetImportiAddiz(richiedente as FormGroup);
        });
        richiedente.get('tipoRavvedimentoSost')?.valueChanges.subscribe(() => {
          this.resetImportiSost(richiedente as FormGroup);
        });
        richiedente.get('tipoTributo')?.valueChanges.subscribe((value) => {
          switch (value) {
            case '1': {
              this.resetImportiSost(richiedente as FormGroup);
              break;
            }
            case '2': {
              this.resetImportiAddiz(richiedente as FormGroup);
              break;
            }
          }
        });
        this.form.get(prov.toLocaleLowerCase()+'Checkbox')?.valueChanges.subscribe((value) => {
          if (value === true) {
            richiedente?.get('tipoTributo')?.setValidators([Validators.required]);
            richiedente?.get('checked')?.patchValue(true);
          } else {
            richiedente?.get('tipoTributo')?.setValidators([]);
            richiedente?.get('checked')?.patchValue(false);
          }
          this.updateTotale();
        });
      }, 100);
    }

    setTimeout(() => {
      this.form.get('ravvedimento')?.valueChanges.subscribe(() => {
        richiedenti.controls.forEach(r => {
          this.resetImporti(r as FormGroup);
        });
      });
      this.form.get('totale')?.disable();
    }, 100);


    if (this.router.getCurrentNavigation()?.extras.state) {
      this.form.get('fkProvincia')?.patchValue((this.router.getCurrentNavigation()?.extras?.state as any)['fkProvincia'] as never);
      this.form.get('fkComune')?.patchValue((this.router.getCurrentNavigation()?.extras?.state as any)['fkComune'] as never);
      this.form.get('cap')?.patchValue((this.router.getCurrentNavigation()?.extras?.state as any)['cap'] as never);
      this.form.patchValue(this.router.getCurrentNavigation()?.extras.state as any, { emitEvent: false, onlySelf: true });
    }

    this.richiedentiFormsInitialized = true;

  }

  get richiedenti(): FormGroup[] {
    return (this.form.get('richiedenti') as any as FormArray).controls as FormGroup[];
  }

  getIdProvince(nome: string): number | null {
    return this.resourceInitializerService.getResource('province')?.find(
      (p: {id: number, nome: string}) => p.nome.toUpperCase() == nome.toUpperCase()
    )?.id;
  }

  getControlLabel(key: string): string {
    return (this.controls_labels as any)[key] || '';
  }

  updateValoreTotali(richiedente: FormControl | FormGroup, prefix: string, suffix: string) {
    const field = richiedente.get(prefix+suffix);
    const fieldValue = Number(field?.value).toFixed(2);
    field?.patchValue(fieldValue);
    const totale = richiedente.get('totale'+suffix);
    let totaleValue = 0;
    if (this.form.get('ravvedimento')?.value === 'SI') {
      totaleValue += Number(richiedente.get('tributo'+suffix)?.value);
      totaleValue += Number(richiedente.get('sanzione'+suffix)?.value);
      totaleValue += Number(richiedente.get('interessi'+suffix)?.value);
    } else {
      totaleValue += Number(richiedente.get('rata'+suffix)?.value);
      totaleValue += Number(richiedente.get('conguaglio'+suffix)?.value);
    }
    totale?.patchValue(
      new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(totaleValue)
    );
    this.updateTotale();
  }

  submit() {
    if (!this.isRiepilogo) {
      this.alerts= [];
      let totaleImpValue = 0;
      this.richiedenti.forEach((richiedente) => {
        if (this.form.get('ravvedimento')?.value === 'SI') {
          totaleImpValue += Number(richiedente.get('tributoAddiz')?.value);
          totaleImpValue += Number(richiedente.get('sanzioneAddiz')?.value);
          totaleImpValue += Number(richiedente.get('interessiAddiz')?.value);
        }
        else {
          totaleImpValue += Number(richiedente.get('rataAddiz')?.value);
          totaleImpValue += Number(richiedente.get('conguaglioAddiz')?.value);
        }
      })

      if (totaleImpValue <= 0) {
        //console.log(totaleImpValue);
        this.alerts.push({ msg: 'Errore: il totale del bollettino non può essere zero o negativo' });
        this.form.setErrors({ 'invalid': true });
        this.scrollToAlerts();
      }

      if (this.form.valid) {
        this.router.navigate(
          ['/public/riepilogo-pagamento'],
          { state: this.form.getRawValue() }
        );
      } else {
        FormUtility.showFormErrors(this.form);
        this.errors = [];
        for (const error of FormUtility.deepSearchErrors(this.form)) {
          this.errors.push({
            field: this.getControlLabel(error.path.split('.')[error.path.split('.').length - 1]),
            msg: this.translate.instant(error.msg, this.form.get(error.path)?.errors as any)
          })
        }

        Object.keys(this.form.controls).forEach(key => {
          if (this.form?.get(key)?.invalid) {
            (<any>this.form.get(key)).nativeElement?.setAttribute("aria-invalid", "true");
          }
        });

        this.scrollToErrors();
      }
    } else {
      this.publicService.confermaPagamento(this.getFormValue()).subscribe({
        error: (err) => {
          this.errors = [];
          const fr = new FileReader();
          fr.onload = (res: any) => {
            let _error = JSON.parse(res.target.result);
            for (const field of Object.keys(_error)) {
              this.errors.push({
                field: this.getControlLabel(field),
                msg: _error[field]
              });
              FormUtility.markAsError(field, this.form, _error[field]);
            }
            this.scrollToErrors();
          };
          fr.readAsText(err.error);
        },
        complete: () => {
          this.router.navigate(
            ['/public/esito-pagamento'],
            {
              state: {
                esito: new Esito('OK', 'Scarica il bollettino di pagamento e pagalo con il metodo che preferisci.', 'Se vuoi modificare i dati e generare un nuovo bollettino, premi il pulsante indietro del browser.')
              }
            }
          );
        },
        next: (value: HttpResponse<Blob>) => {
          FileUtility.downloadFile(value);
        },
      });
    }
  }

  indietro() {
    this.router.navigate(
      ['/public/pagamento'],
      { state: this.form.getRawValue() }
    );
  }

  resolved(captchaResponse: any) {
    this.form.get('recaptcha')?.patchValue(captchaResponse as never);
  }

  scrollToErrors(): void {
    setTimeout(() => {
      const _errorsWrapper = document.querySelector('#errors');
      if (_errorsWrapper) {
        window.scrollTo({top: _errorsWrapper.getBoundingClientRect().top + window.pageYOffset - 200, behavior: 'smooth'});
      }
    })
  }

  scrollToAlerts(): void {
    setTimeout(() => {
      const _errorsWrapper = document.querySelector('#alerts');
      if (_errorsWrapper) {
        window.scrollTo({top: _errorsWrapper.getBoundingClientRect().top + window.pageYOffset - 200, behavior: 'smooth'});
      }
    })
  }

  resetImporti(richiedente: FormGroup) {
    this.resetImportiAddiz(richiedente);
    this.resetImportiSost(richiedente);
  }

  resetImportiAddiz(richiedente: FormGroup) {
    richiedente.get('rataAddiz')?.patchValue('0.00');
    richiedente.get('conguaglioAddiz')?.patchValue('0.00');
    richiedente.get('tributoAddiz')?.patchValue('0.00');
    richiedente.get('sanzioneAddiz')?.patchValue('0.00');
    richiedente.get('interessiAddiz')?.patchValue('0.00');
    richiedente.get('totaleAddiz')?.patchValue('0.00');
    this.updateTotale();
  }

  resetImportiSost(richiedente: FormGroup) {
    richiedente.get('rataSost')?.patchValue('0.00');
    richiedente.get('conguaglioSost')?.patchValue('0.00');
    richiedente.get('tributoSost')?.patchValue('0.00');
    richiedente.get('sanzioneSost')?.patchValue('0.00');
    richiedente.get('interessiSost')?.patchValue('0.00');
    richiedente.get('totaleSost')?.patchValue('0.00');
    this.updateTotale();
  }

  getFormValue() {
    const formValue = this.form.getRawValue() as any;
    formValue.richiedenti = (formValue.richiedenti as any[]).filter(r => r.checked);
    return formValue;
  }

  updateTotale() {
    let totale = 0;
    for(const richiedente of this.richiedenti) {
      if (richiedente?.get('checked')?.value) {
        if (this.form.get('ravvedimento')?.value === 'SI') {
          if (richiedente.get('tipoTributo')?.value == '1') {
            totale += Number(richiedente.get('tributoAddiz')?.value);
            totale += Number(richiedente.get('sanzioneAddiz')?.value);
            totale += Number(richiedente.get('interessiAddiz')?.value);
          } else {
            totale += Number(richiedente.get('tributoSost')?.value);
            totale += Number(richiedente.get('sanzioneSost')?.value);
            totale += Number(richiedente.get('interessiSost')?.value);
          }
        } else {
          if (richiedente.get('tipoTributo')?.value == '1') {
            totale += Number(richiedente.get('rataAddiz')?.value);
            totale += Number(richiedente.get('conguaglioAddiz')?.value);
          } else {
            totale += Number(richiedente.get('rataSost')?.value);
            totale += Number(richiedente.get('conguaglioSost')?.value);
          }
        }
      }
    }
    this.form.get('totale')?.patchValue(
      new Intl.NumberFormat('it-IT', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(totale) as never
    )
  }

  codAccisaValid() {
    return this.form.get('codAccisa')?.invalid && this.form.get('codAccisa')?.touched;
  }

  ragioneSocialeValid() {
    return this.form.get('ragioneSociale')?.invalid && this.form.get('ragioneSociale')?.touched;
  }

  cfValid() {
    return this.form.get('cf')?.invalid && this.form.get('cf')?.touched;
  }

  emailValid() {
    return this.form.get('email')?.invalid && this.form.get('email')?.touched;
  }

  fkProvinciaValid() {
    return this.form.get('fkProvincia')?.invalid && this.form.get('fkProvincia')?.touched;
  }

  fkComuneValid() {
    return this.form.get('fkComune')?.invalid && this.form.get('fkComune')?.touched;
  }
  capValid() {
    return this.form.get('cap')?.invalid && this.form.get('cap')?.touched;
  }
  indirizzoValid() {
    return this.form.get('indirizzo')?.invalid && this.form.get('indirizzo')?.touched;
  }
  txtNumeroValid() {
    return this.form.get('txtNumero')?.invalid && this.form.get('txtNumero')?.touched;
  }
  fkNazioneValid() {
    return this.form.get('fkNazione')?.invalid && this.form.get('fkNazione')?.touched;
  }
  annoPagamentoValid() {
    return this.form.get('annoPagamento')?.invalid && this.form.get('annoPagamento')?.touched;
  }
  meseVersamentoValid() {
    return this.form.get('meseVersamento')?.invalid;
  }


  checkValidity(elem:any, searchTerm:any) {
    setTimeout(() => {
      if (this.form.get(searchTerm)?.invalid) {
        elem.setAttribute("aria-invalid", "true");
      } else {
        elem.setAttribute("aria-invalid", "false");
      }
    }, 100);
  }

  get emailIsInvalidAndTouched() {
    return  this.form.get('codAccisa')?.invalid && this.form.get('codAccisa')?.touched;
  }

}
